module.exports = __webpack_public_path__ + "img/wreck_TH.935049f4.png";